import { apiClient } from "@/lib/api";

// Billing
export const getBilling = () => apiClient.get("/company/billing");
export const changePlan = (plan) => apiClient.post("/company/billing/change-plan", { plan });
export const buyCredits = (credits) => apiClient.post("/company/billing/buy-credits", { credits });

// Company
export const createCompany = (payload) => apiClient.post("/company", payload);
export const getMyCompany = () =>
  apiClient.get("/company/me", {
    // 404 is a valid "no workspace yet" response — don't throw / surface error overlay
    validateStatus: (s) => (s >= 200 && s < 300) || s === 404,
  });
export const patchMyCompany = (patch) => apiClient.patch("/company/me", patch);

// Jobs (company side)
export const createJob = (payload) => apiClient.post("/company/jobs", payload);
export const listMyJobs = () => apiClient.get("/company/jobs");
export const getJob = (id) => apiClient.get(`/company/jobs/${id}`);
export const patchJob = (id, patch) => apiClient.patch(`/company/jobs/${id}`, patch);
export const deleteJob = (id) => apiClient.delete(`/company/jobs/${id}`);
export const getSyndication = (id) => apiClient.get(`/company/jobs/${id}/syndication`);

// Applications (company side)
export const listJobApplications = (jobId) =>
  apiClient.get(`/company/jobs/${jobId}/applications`);
export const updateApplication = (applicationId, body) =>
  apiClient.patch(`/company/applications/${applicationId}`, body);

// Talent Pool
export const talentPool = (role, limit = 50) =>
  apiClient.get("/company/talent-pool", { params: { role, limit } });

// Assessments (company)
export const createAssessment = (payload) =>
  apiClient.post("/company/assessments", payload);
export const listAssessments = () => apiClient.get("/company/assessments");
export const listSubmissions = (assessmentId) =>
  apiClient.get(`/company/assessments/${assessmentId}/submissions`);

// Public jobs (candidate side)
export const publicJobs = (q) =>
  apiClient.get("/jobs", { params: q ? { q } : {} });
export const publicJob = (id) => apiClient.get(`/jobs/${id}`);
export const applyToJob = (id) => apiClient.post(`/jobs/${id}/apply`);
export const getJobScreening = (id) => apiClient.get(`/jobs/${id}/screening`);
export const submitScreening = (id, answers, proctor) => apiClient.post(`/jobs/${id}/screening/submit`, { answers, proctor });
export const myApplications = () => apiClient.get("/applications/mine");

// Assessment (candidate)
export const getAssessment = (id) => apiClient.get(`/assessments/${id}`);
export const submitAssessment = (id, answers) =>
  apiClient.post(`/assessments/${id}/submit`, { answers });

// Sprint 2 — Company advanced features
export const generateJD = (role, skills, experience) =>
  apiClient.post("/company/jobs/generate-jd", { role, skills, experience });
export const getScreeningQuestions = (jobId) =>
  apiClient.post(`/company/jobs/${jobId}/screening-questions`);
export const getCandidateProfile = (userId, jobId) =>
  apiClient.get(`/company/candidates/${userId}`, { params: jobId ? { job_id: jobId } : {} });
export const updateApplicationNote = (applicationId, note, tags) =>
  apiClient.patch(`/company/applications/${applicationId}/note`, { note, tags });
export const bulkApplicationAction = (application_ids, action, stage) =>
  apiClient.post("/company/applications/bulk", { application_ids, action, stage });
export const getHiringFunnel = () => apiClient.get("/company/analytics/funnel");
export const getCompanyAttention = () => apiClient.get("/company/attention");
export const getSyndicationLinks = (jobId) => apiClient.get(`/company/jobs/${jobId}/syndication-links`);
export const publicJobApply = (id, source) => apiClient.post(`/jobs/${id}/apply`, {}, { params: source ? { source } : {} });

// Connectors
export const listConnectors = () => apiClient.get("/company/connectors");
export const saveConnector = (id, config) => apiClient.post(`/company/connectors/${id}`, { config });
export const deleteConnector = (id) => apiClient.delete(`/company/connectors/${id}`);
export const distributeJob = (jobId) => apiClient.post(`/company/jobs/${jobId}/distribute`);
export const getDistributionStatus = (jobId) => apiClient.get(`/company/jobs/${jobId}/distribution`);
